module.exports = __webpack_public_path__ + "static/media/stars.575da69d.svg";